module.exports = __webpack_public_path__ + "static/img/live-to-learn__large.3a943ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/live-to-learn__large.jpg
// module id = Yrgb
// module chunks = 1